<div (document:click)="focusInput($event); clicked($event.target)" class="custom-input" style="position: relative;">
	<mat-form-field [class]="class">
		@if (label || required) {
			<mat-label>{{ label }}</mat-label>
		}
		<input matInput #input [(ngModel)]="displayValue" [required]="required" autocompleteOff />
		@if (!required && inline) {
			<button [class.hidden]="!value" matSuffix mat-icon-button (click)="resetInput()" class="mat-fa-icon mat-hover-button">
				<mat-icon fontSet="fal" fontIcon="fa-times" />
			</button>
		}
		@if (!hasFocus) {
			<mat-datepicker-toggle matSuffix (focus)="setFocus(true)" />
		}
	</mat-form-field>

	@if (displayDatePicker) {
		<div class="calendar-popup" [class.inline]="inline">
			<div class="row pop-out">
				@if (!inline) {
					<div class="col-12">
						<mat-form-field [class]="class">
							@if (label || required) {
								<mat-label>{{ label }}</mat-label>
							}
							<input matInput #input [(ngModel)]="displayValue" [required]="required" autocompleteOff />
							@if (!required) {
								<button [class.hidden]="!value" matSuffix mat-icon-button (click)="resetInput()" class="mat-fa-icon mat-hover-button">
									<mat-icon fontSet="fal" fontIcon="fa-times" />
								</button>
							}
						</mat-form-field>
					</div>
				}
				<div class="col-6">
					<div class="time-picker-top"><icon small type="calendar-alt" /> {{followUpDate ? (followUpDate | customDate: 'shortDate') : 'general.pick-date' | translate }}</div>
					<date-picker [maxDate]="maxDate" [minDate]="minDate" [suggestedMinDate]="suggestedMinDate" [markedDates]="markedDates" [(model)]="followUpDate" (modelChange)="valueChanged()" />
				</div>
				<div class="col-6">
					<div class="time-picker-top"><icon small type="clock" /> {{followUpTime && followUpTime.currentTime != '' ? followUpTime.currentTime : 'general.pick-time' | translate }}</div>
					<time-picker [optional]="timeOptional" [range]="timeRange" [(model)]="followUpTime" (modelChange)="valueChanged()" />
				</div>
			</div>
		</div>
	}
</div>
